import styled from 'styled-components'

export const Container = styled.div`
  position: relative;

  padding: 30px 20px;

  background-color: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#fff')};

  border-radius: 24px 24px 0 0;

  .close {
    border: none;
    background: none;

    width: 36px;
    height: 36px;

    position: absolute;

    top: 20px;
    right: 20px;

    svg {
      path {
        stroke: rgb(${({ theme }) => theme.grayscale[100]});
      }
    }
  }

  .name {
    color: rgb(${({ theme }) => theme.grayscale[100]});

    margin-bottom: 4px;

    font-size: 18px;
    font-weight: 700;
    line-height: 120%;
  }

  .infos {
    color: rgb(${({ theme }) => theme.grayscale[200]});

    margin-bottom: 36px;

    .info {
      display: inline-block;
      white-space: inherit;
    }
  }

  .buttons {
    display: flex;
    flex-direction: column;
    gap: 30px;

    button {
      display: flex;
      justify-content: center;

      font-size: 16px;
      font-weight: 600;
      line-height: 140%;

      border-radius: 4px;
      border-width: 1px;
      border-style: solid;
      border-color: ${({ theme }) => `rgb(${theme.primary.base})`};

      color: ${({ theme }) => `rgb(${theme.primary.base})`};

      background: none;

      width: 100%;

      padding: 14px 0;
    }
  }

  @media only screen and (min-width: 800px) {
    border-radius: 16px;
  }
`
